import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const HomeworkLazy = React.lazy(
	() => import(/* webpackChunkName : 'Homework' */ './components')
);

export default (store) => {
	return {
		path: 'homework',
		element: <AsyncLoading component={<HomeworkLazy />} />,
	};
};
